import TourgevilleApril2025 from "../../components/before-after/TourgevilleApril2025";

const TourgevilleApril2025View = () => {

    return (
        <div className="before-after-tourgeville-april-2025">
            <TourgevilleApril2025/>
        </div>
    );
};

export default TourgevilleApril2025View;